import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const Forbidden403 = () => (
  <Box sx={{ p: 6, textAlign: 'center' }}>
    <Typography variant="h3" gutterBottom>403 - Forbidden</Typography>
    <Typography variant="body1" color="text.secondary" gutterBottom>
      You do not have permission to view this page.
    </Typography>
    <Button variant="contained" component={RouterLink} to="/">Go to Dashboard</Button>
  </Box>
);

export default Forbidden403;

